<template>
  <div
    class="ping-wrapper"
    :class="{'show-ping' : show}"
  >
    <span class="ping-dot" />
    <span class="ping-anim" />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.ping-wrapper {
  position: relative;
  width: 0;
  height: 0;
  visibility: hidden;
  opacity: 0;
  transition: all .5s ease;

  .ping-dot {
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 6px;
    background-color: red;
    border-radius: 9999px;
    z-index: 2;
  }

  .ping-anim {
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 6px;
    background-color: red;
    border-radius: 9999px;
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
    z-index: 1;
    opacity: 0.75;
  }
}
.show-ping {
  width: 6px;
  height: 6px;
  visibility: visible;
  opacity: 1;
  margin-left: 10px;
}

@keyframes ping {
  0% {
    transform: scale(1);
    opacity: 0.75;
  }
  75%, 100% {
    transform: scale(2.5);
    opacity: 0;
  }
}
</style>
